<template>
  <div id="app-inner">
    <div class="page-loading" v-show="$store.state.pageLoading">
      <van-loading type="spinner" size="34" color="#D8B278" vertical> 加载中... </van-loading>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { Loading } from 'vant'
export default {
  name: 'app',
  components: {
    [Loading.name]: Loading,
  },
  mounted() {
    // 监听窗口高度变化，如果高度比初始状态小，则说明键盘弹起。可以用于解决fixed定位元素，被键盘推上去的问题
    this.winHeight = document.body.clientHeight || document.documentElement.clientHeight
    window.addEventListener('resize', () => {
      console.log(document.body.clientHeight)
      const winHeight = document.body.clientHeight || document.documentElement.clientHeight
      this.$store.commit('setKeyboardUp', winHeight < this.winHeight)
    })

    if (hcApp.isHCApp()) {
      // 获取状态栏高度，并存入store
      hcApp
        .postMessage({
          methodName: 'getStatusHeight',
        })
        .then((res) => {
          const height = Number(res.height)
          this.$store.commit('setStatusHeight', isNaN(height) ? 32 : height)
        })
    } else {
      this.$store.commit('setStatusHeight', 0)
    }

    // ios需要适配，android webview默认从安全区上方开始
    if (hcApp.isHCIOSApp()) {
      // 获取底部安全区高度，并存入store
      hcApp
        .postMessage({
          methodName: 'getSafeBottomHeight',
        })
        .then((res) => {
          const height = Number(res.height)
          this.$store.commit('setSafeBottomHeight', isNaN(height) ? 40 : height)
        })
    }
  },
}
</script>

<style lang="scss">
@import '@/styles/index.scss';
@import '@/styles/rem/reset.scss';

#app-inner {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.page-loading {
  position: fixed;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
</style>
